import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import ViewHeader from '../components/ViewHeader';
import KpiCard from '../components/KpiCard';
import CategoryBar from '../components/CategoryBar';

const kpis = [
    { title: 'Appointment', value: '12', change: '12%', changeType: 'up' },
    { title: 'No show rate', value: '5', change: '9%', changeType: 'down' },
    { title: 'Completed', value: '15', change: '9%', changeType: 'down' },
];

const statusBars = [
    { label: 'Completed', value: 15 },
    { label: 'Scheduled', value: 12 },
    { label: 'No shows', value: 5 },
];

const providerBars = [
    { label: 'Dr. Ali', value: 45 },
    { label: 'Dr. Sarah', value: 28 },
];

const timeData = [
    { name: 'Jan', value: 32 },
    { name: 'Feb', value: 34 },
    { name: 'Mar', value: 21 },
    { name: 'Apr', value: 11 },
    { name: 'May', value: 32 },
    { name: 'Jun', value: 34 },
    { name: 'Jul', value: 21 },
    { name: 'Aug', value: 11 },
    { name: 'Sep', value: 21 },
    { name: 'Oct', value: 11 },
    { name: 'Nov', value: 32 },
    { name: 'Dec', value: 23 },
];

const AppointmentClinicalFlow = ({ onBack }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <ViewHeader title="Appointment Clinical Flow (Monthly)" subtitle="2026" onBack={onBack} />

            <div className="clinic-dashboard-growth-grid auto-rows">
                {/* Left column - stacked cards */}
                <div className="clinic-dashboard-growth-left-top clinic-dashboard-section-card" style={{ alignSelf: 'start', animationDelay: '0ms' }}>
                    <div className="clinic-dashboard-section-title">Key metrics</div>
                    <div className="clinic-dashboard-kpi-row">
                        {kpis.map((kpi, i) => <KpiCard key={i} {...kpi} />)}
                    </div>
                </div>

                <div className="clinic-dashboard-growth-left-mid clinic-dashboard-section-card" style={{ alignSelf: 'start', animationDelay: '80ms' }}>
                    <div className="clinic-dashboard-section-title">Appointments status</div>
                    <div className="clinic-dashboard-catbar-list medium">
                        {statusBars.map((bar, i) => <CategoryBar key={i} {...bar} />)}
                    </div>
                </div>

                <div className="clinic-dashboard-growth-left-bot clinic-dashboard-section-card" style={{ alignSelf: 'start', animationDelay: '160ms' }}>
                    <div className="clinic-dashboard-section-title">Appointments by provider</div>
                    <div className="clinic-dashboard-catbar-list medium">
                        {providerBars.map((bar, i) => <CategoryBar key={i} {...bar} />)}
                    </div>
                </div>

                {/* Right column - tall chart spanning all rows */}
                <div className="clinic-dashboard-growth-right clinic-dashboard-section-card" style={{ animationDelay: '240ms' }}>
                    <div className="clinic-dashboard-section-title">Appointments over time</div>
                    <div className="clinic-dashboard-chart-wrap" style={{ minHeight: '260px' }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <LineChart data={timeData} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                                <XAxis
                                    dataKey="name"
                                    axisLine={false}
                                    tickLine={false}
                                    tick={{ fill: '#9ca3af', fontSize: 12 }}
                                />
                                <YAxis
                                    axisLine={false}
                                    tickLine={false}
                                    tick={{ fill: '#9ca3af', fontSize: 12 }}
                                />
                                <Tooltip
                                    contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                                />
                                <Line animationBegin={600} type="monotone" dataKey="value" stroke="#0f766e" strokeWidth={2} dot={{ r: 4, fill: '#0f766e' }} activeDot={{ r: 6 }} name="appointments" />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AppointmentClinicalFlow;
